import store from "../store";
import { actionTypes } from "./saga";

/**
 *
 * @param {object} procedureHistory
 */
export function putProceduresHistory(data, filters) {
  store.dispatch({
    type: actionTypes.PUT_PROCEDURE_HISTORY_DATA,
    payload: {
      data: data,
      filters: filters
    }
  });
}

export function getProcedureHistoryAsset(data) {
  store.dispatch({
    type: actionTypes.GET_PROCEDURE_HISTORY_ASSETS,
    payload: {
      data: data
    }
  });
}
